import { Box, Stack, Typography } from "@mui/material";
import type { GoalOverview } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { GoalTimelineRow } from "./GoalTimelineRow";

const Archived = Resources.AnalysisDetail.Goals.Timeline.Archived;

type Props = {
  goals: GoalOverview[];
  onEdit: (goal: GoalOverview) => void;
};

export const ArchivedGoals = ({ goals, onEdit }: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={Spacing.M}>
      <Typography variant="subtitle1" fontWeight={600}>
        {t(Archived.Title)}
      </Typography>

      {goals.length > 0 ? (
        <Box>
          {goals.map((goal) => (
            <GoalTimelineRow key={goal.guid} goal={goal} onEdit={onEdit} />
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t(Archived.Subtitle)}
        </Typography>
      )}
    </Stack>
  );
};
